(() => {
  if (customElements.get('ug-variant-packaging')) return;
  class VariantPackaging extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.style.display = 'block';
      this.scope = this.closest('[id^="shopify-section-"]') || document;
      this.refresh = () => {
        const selector = this.dataset.section && document.getElementById('id-' + this.dataset.section);
        const input = selector || this.scope.querySelector('select[name="id"],form[action*="/cart/add"] [name="id"]');
        const id = input ? String(input.value || '') : this.dataset.initialVariant;
        if (id === this.current) return;
        const output = this.querySelector('[data-packaging-output]');
        const template = [...this.querySelectorAll('template[data-packaging-variant]')].find(t => t.dataset.packagingVariant === id) || this.querySelector('template[data-packaging-common]');
        if (!output || !template) return;
        this.current = id;
        output.replaceChildren(template.content.cloneNode(true));
        output.hidden = !output.textContent.trim();
      };
      this.scope.addEventListener('change', this.refresh);
      // The theme also sets the hidden master selector programmatically without a change event.
      this.timer = setInterval(this.refresh, 300);
      this.refresh();
    }
    disconnectedCallback() {
      clearInterval(this.timer);this.timer = null;
      this.scope?.removeEventListener('change', this.refresh);
    }
  }
  customElements.define('ug-variant-packaging', VariantPackaging);
})();
